(function () {
    "use strict";

    /**
     * Sitecat metrics that should be applicable for every site
     * Created by maktarh on 23/03/2017.
     * @constructor
     */
    function SharedMetrics() {
        this.environment = window.nadex.marketing.analytics.environment;
        this.url = window.nadex.marketing.analytics.url;
        this.cookie = window.nadex.marketing.analytics.cookie;
    }

    /**
     * set the page name and url details
     * @param url
     * @param pageName
     * @param trackingObject
     * @function
     */
    SharedMetrics.prototype.identifyPage = function (url, pageName, trackingObject) {
        trackingObject.prop5 = url;
        trackingObject.pageName = pageName;
        trackingObject.eVar1 = trackingObject.prop9 = trackingObject.prop30 = 'D=pageName';
    };

    /**
     * @function - sets up tracking of links and downloads
     * @param trackingObject - the global sitecat object
     */
    SharedMetrics.prototype.trackLinks = function (trackingObject) {
        trackingObject.trackDownloadLinks = true; //create a file download report
        trackingObject.linkDownloadFileTypes = 'exe,zip,wav,mp3,mov,mpg,avi,wmv,pdf,doc,docx,xls,xlsx,ppt,pptx,xml';
        trackingObject.trackExternalLinks = true;
        trackingObject.trackInlineStats = true; //generates a clickmap
    };

    /**
     * @function - sets the site catalyst visitor id
     * @param trackingObject - the global sitecat object
     */
    SharedMetrics.prototype.setVisitorID = function (trackingObject) {
        trackingObject.eVar25 = trackingObject.prop25 = "D=s_vi";
    };

    /**
     * @function - set a prop to check if the request started in visitorapi (head-tracking.js) is already done and that the Visitor class is available on the time of tracking
     * @param trackingObject - the global sitecat object
     */
    SharedMetrics.prototype.setVisitorIDCheck = function (trackingObject) {
        trackingObject.prop53 = typeof(Visitor) != "undefined";
    };

    /**
     * Sets the chid value if present
     * @function
     * @param trackingObject - the global sitecat object
     * @param   mockUrl
     */
    SharedMetrics.prototype.setChid = function (trackingObject, mockUrl) {
        var urlObject = mockUrl || this.url;
        var chid = urlObject.getQueryStringParameter('CHID');
        if (!chid) {
            //check if someone has set the CHID in lowercase
            chid = urlObject.getQueryStringParameter('chid');
        }
        if (chid) {
            trackingObject.eVar58 = chid;
        }
    };

    /**
     * Sets the qpid value to first and contributing qpid eVars
     * @param trackingObject - the global sitecat object
     * @param   mockUrl
     */
    SharedMetrics.prototype.setQpid = function (trackingObject, mockUrl) {
        var urlObject = mockUrl || this.url;
        var qpid = urlObject.getQueryStringParameter('QPID');
        if (!qpid) {
            //check if someone has added the qpid in lowercase
            qpid = urlObject.getQueryStringParameter('qpid');
        }
        if (qpid) {
            trackingObject.eVar9 = qpid;
            trackingObject.eVar10 = qpid;
        }
    };

    /**
     * Sets the report suite to evar 22 so different sites can be identified in rollups
     * @param trackingObject - the global sitecat object
     * @param settings
     */
    SharedMetrics.prototype.setReportSuite = function (trackingObject, settings) {
        if (settings.hasOwnProperty("mainReportSuite") && settings.mainReportSuite) {
            trackingObject.eVar22 = settings.mainReportSuite;
        }
    };

    /**
     * Checks if the tracking ID has been passed in on the query string and saves it in a cookie as well as adding it to sitecat
     * @param trackingObject - the global sitecat object
     */
    SharedMetrics.prototype.setTrackingId = function (trackingObject) {
        var client_id = this.url.getQueryStringParameter('tid');

        if (this.cookie) {
            if (!client_id) {
                client_id = this.cookie.get('evar61');
            } else {
                //set the tracking ID obtained from the url
                //this.cookie.set('client_id', client_id, 365, window.location.hostname);
            }
        }
        if (typeof client_id !== 'undefined') {
            trackingObject.eVar61 = client_id;
        }
    };

    /**
     * @function - Gets the cross site ID if not already stored in a local cookie.
     * @param trackingObject - the global sitecat object
     * @returns {*} A jQuery deferred object that contains the result of the call to the identity service
     */
    SharedMetrics.prototype.setCrossSiteId = function (trackingObject) {
        var crossSiteId = this.cookie.get("x_userid");
        //var websiteEnvironment;
        var deferredIdentityResult;

        /*
        //not applicable to nadex
        if (crossSiteId.length === 0) {

            websiteEnvironment = this.environment.getWebsiteEnvironmentPrefix();
            if (this.environment.determineEnvironment() === 'local') {
                websiteEnvironment = 'net';
            }

            deferredIdentityResult = jQuery.ajax({
                type: "POST",
                url: "https://net.marketdatasystems.com/identity.php",
                dataType: 'jsonp',
                crossDomain: true
            })
                .done(function (data) {
                    if (data && data.x_userid) {
                        this.cookie.set('x_userid', data.x_userid, 365, window.location.hostname);
                        trackingObject.eVar53 = data.x_userid;
                    }
                }.bind(this))
                .fail(function (data, error) {
                    if (console && console.log) {
                        console.log('Error: ', error)
                    }
                });

        } else {
        */
            //if no ajax call was made return a resolved deferred object
            // so we can treat the results in the same way
            trackingObject.eVar53 = crossSiteId;
            //deferredIdentityResult = jQuery.Deferred().resolve();
            deferredIdentityResult = true;
            //console.log("deferred:", deferredIdentityResult);
        //}

        return deferredIdentityResult;
    };

    /**
     * @function - Initialises the tracking object with metrics applicable to all sites
     * and returns the deferred object that is returned from the cross site id call
     * @param trackingObject - the global site cat object
     * @param settings - site specific configuration such as report suites
     * @param pageObject override for default functions to get page name
     * @param urlObject override for default functions to get and format url
     */
    SharedMetrics.prototype.initialise = function (trackingObject, settings, pageObject, urlObject) {
        var page = pageObject || window.nadex.marketing.analytics.page;
        var url = urlObject || window.nadex.marketing.analytics.url;

        //make sure we have a valid report suite
        if (!(settings.hasOwnProperty("mainReportSuite") && settings.mainReportSuite)) {
            throw {
                name: 'Invalid report suite error',
                message: 'main report suite is missing'
            }
        }

        this.trackLinks(trackingObject);
        this.setChid(trackingObject);
        this.setQpid(trackingObject);
        this.setReportSuite(trackingObject, settings);
        this.identifyPage(url.getCurrentUrl(), page.getPageName(), trackingObject);
        this.setTrackingId(trackingObject);
        this.setVisitorID(trackingObject);
        this.setVisitorIDCheck(trackingObject);
        return this.setCrossSiteId(trackingObject);
    };

    window.nadex = window.nadex || {};
    window.nadex.marketing = window.nadex.marketing || {};
    window.nadex.marketing.analytics = window.nadex.marketing.analytics || {};
    window.nadex.marketing.analytics.sharedMetrics = new SharedMetrics();
}());